import { Component, OnInit, ViewChild } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

import { PracticasComponent } from "./practicas/practicas.component";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { ForAllService } from 'app/main/wizard-cgo/services/forall.service';
import { ForAllService as ForAllSrv } from './for-all.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';

@Component({
  selector: 'app-for-all',
  templateUrl: './for-all.component.html',
  styleUrls: ['./for-all.component.scss']
})
export class ForAllComponent implements OnInit {

  @ViewChild(PracticasComponent) nativo: PracticasComponent;
  actualizaTraducciones: Subject<any> = new Subject<any>();
  statusPaso: Subject<any> = new Subject<any>();

  numeroPracticas: number;
  instituto: string;
  pasoCompleto = false;
  productoCertificar: any;
  token: any;
  practicasCompletas = true;

  validationUser: boolean;
  desbloqueoEstatus: boolean;
  validationSurvey: boolean;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private forallService: ForAllService,
    private forAllSrv: ForAllSrv,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('userBypass')){
      let userData = JSON.parse(localStorage.getItem('userBypass'));
      if(userData.level==3 || userData.level==2){
        this.validationUser=true;
      }
      else{
        this.validationUser=false;
      }
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.getInstituto();
  }

  actualiza(event:any){
    this.actualizaTraducciones.next(event);
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; this.practicasCompletas = false; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '8': case 'IZZI': this.instituto = 'IZZI'; break;
      case '11': case 'BR': this.instituto = 'BR'; this.practicasCompletas = false; break;
      case '15': case 'ES': this.instituto = 'ES'; break;
    }
  }
  showHtml:boolean=false;
  numPracticas(numero:number){
    this.numeroPracticas = numero;
  }
  traducciones: any;
  idiomas: any;
  getIdiomasEncuesta(){
    let data = {
      fechaCertificar:localStorage.getItem('fechaProducto')
    };
    this.traducciones = [];
    this.forallService.getIdiomasEncuesta(data).subscribe((respuesta:any) => {
      console.log("getIdiomasEncuesta:",respuesta);
      this.idiomas = respuesta.idiomasMostrar;
      console.log(this.idiomas.length);
      if(this.idiomas.length>0){
        this.showHtml=true;
      }

    }, error => {
      console.log("error", error);
    })
  }
  obtieneCertificarActual(){

    this.forallService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;

      let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
      if(indiceProducto != -1){
        this.productoCertificar = prodsCertificar[indiceProducto];
        this.token = prodsCertificar[indiceProducto].tokenConfig;
        this.getStatusEncuesta(this.token);
        this.getEstatusDesbloqueo();
        this.getIdiomasEncuesta();
      }
      //obtiene el status del paso adicionales del certificar vigente
      this.forallService.getStatusForAll(localStorage.getItem('productoID')).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3){
          this.pasoCompleto = true;
        }
        this.statusPaso.next(this.pasoCompleto);
      });
      this.getStatusModal();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      //console.log("error al recuperar certificar vigente");
    });
  }

  getStatusEncuesta(token:any){
    if(token){
      this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
        // console.log(data);
        if(data.result.id_status == 1){
          this.validationSurvey = true;
        }
        else{
          this.validationSurvey = false;
        }
      });
    }
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo){
        this.desbloqueoEstatus = true;
      }
      else{
        this.desbloqueoEstatus = false;
      }
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      forall: 1
    };
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('FORALL');
      }
    });
  }
  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      forall: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }
  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      //this.aletaRestric('FORALL.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      //this.alertaRestric2('IDIOMAS.COMPLETADO',null,'warning');
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: 'bottom',
        panelClass: ['background-red']
      });
    }
    else{
      this.modalGuardado();
      this.validacionPracticas();
    }
  }

  validacionPracticas(){
    let datos = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
    this.forallService.getPracticesSaved(datos).subscribe((respuesta:any) => {
      console.log("respuesta:",respuesta);

      if(respuesta.message == 200){
        let primerPaso = false;
        let segundoPaso = false;
        let tercerPaso = false;
        let practicasGuardadas = respuesta.practicas;
        console.log("practicasGuardadas:",practicasGuardadas.length," numPracticas:",this.numeroPracticas);

        if(practicasGuardadas.length == this.numeroPracticas){   //si las practicas guardadas coinciden en numero con las practias totales posibles
          primerPaso = true;
        }
        else{
          if(this.practicasCompletas){    //si es necesario tener todas las practicas
            primerPaso = false;
          }
          else{   //si no es necesario tener todas las prácticas
            primerPaso = true;
          }
        }

        console.log("primerPaso:",primerPaso);

        if(primerPaso){
          if(practicasGuardadas){
            let practicasCompletas = true;
            let BreakException = {};
            try {
              practicasGuardadas.forEach(practica => {
                // console.log("practica:",practica);
                if(!practica.practicaForall || !practica.descripcionForall){
                  practicasCompletas = false;
                  throw BreakException;
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            };
            if(practicasCompletas){
              segundoPaso = true;
            }else{
              segundoPaso = false;
            }
          }else{
            segundoPaso = false;
          }

          console.log("segundoPaso:",segundoPaso);

          if(segundoPaso){
            this.forAllSrv.getIdiomasEncuesta(datos).subscribe((respuestaIdiomas:any) => {
              console.log("respuestaIdiomas:",respuestaIdiomas);

              if(respuestaIdiomas.idiomasMostrar.length == 0){
                tercerPaso = true;
              }
              else{
                let BreakException = {};
                try {
                  respuestaIdiomas.idiomasMostrar.forEach(idioma => {
                    let idiomaCompleto = true;
                    let BreakException2 = {};
                    try {
                      practicasGuardadas.forEach(practica => {
                        if(practica.traducciones.length > 0){
                          if(practica.traducciones.length == respuestaIdiomas.idiomasMostrar.length){
                            let indiceTraduccion = practica.traducciones.findIndex(item => item.idioma == idioma._id);
                            if(indiceTraduccion != -1){
                              if(!practica.traducciones[indiceTraduccion].practicaForall || !practica.traducciones[indiceTraduccion].descripcionForall){
                                console.log("tronó aqui, datos:",practica.traducciones[indiceTraduccion]);
                                idiomaCompleto = false;
                                throw BreakException2;
                              }
                            }
                            else{
                              console.log("trono aqui");
                              idiomaCompleto = false;
                              throw BreakException2;
                            }
                          }
                          else{
                            console.log("trono aqui");
                            idiomaCompleto = false;
                            throw BreakException2;
                          }
                        }
                        else{
                          console.log("trono aqui");
                          idiomaCompleto = false;
                          throw BreakException2;
                        }
                      });
                    } catch (e) {
                      if (e !== BreakException2) throw e;
                    };

                    if(idiomaCompleto){
                      tercerPaso = true;
                    }
                    else{
                      tercerPaso = false;
                      throw BreakException;
                    }

                  });
                } catch (e) {
                  if (e !== BreakException) throw e;
                };
              }

              if(tercerPaso){
                console.log("felicidades prro, tus practicas forall estan completas alv");
                this.aletaRestric('FORALL.COMPLETAR',true);
              }
              else{
                console.log("entro este caso");
                this.aletaRestric('FORALL.NADA_TRA',null,'warning');
              }

            }, error => {
              console.log("error", error);
            });
          }
          else{
            console.log("entro este caso");
            this.aletaRestric('FORALL.NADA',null,'warning');
          }

        }
        else{
          console.log("entro este caso");
          this.aletaRestric('FORALL.NADA',null,'warning');
        }

      }
    });
  }

  modalGuardado(){
    let mensaje: string;
    this.translateSrv.get('CERTIFICAR.FORALL.REVISANDO_PRACTICAS').subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'completePas4all',
            productoId:this.productoCertificar.idCertificar,
            forall: 3
          }
          console.log("completar paso 4all");
          this.forallService.guardaStatusForAll(datos).subscribe( (data: any) => {
            if(data.message == '212'){
              //this.aletaRestric('FORALL.'+data.message,null,'success');
              let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
              this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
              this.openSnackBar(textoMensaje,"OK");
              this.pasoCompleto = true;
              this.statusPaso.next(this.pasoCompleto);
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }
  desbloquear4all(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.FORALL.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePas4all',
            productoId:this.productoCertificar.idCertificar,
            forall: 2
          }
          console.log("Descompletar paso 4all");
          this.forallService.DesbloquearPasoForAll(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '212'){
               this.pasoCompleto = false;
               this.openSnackBar(succes,"OK");
               this.enviaOrdenWizard();
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

}
